if (!customElements.get('snack-inline-search')) {
  customElements.define('snack-inline-search', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.input = this.querySelector('input[type="search"]');
      this.panel = this.querySelector('.snack-inline-results');
      this.results = this.querySelector('[data-inline-results]');
      this.status = this.querySelector('[data-inline-status]');
      this.all = this.querySelector('[data-inline-all]');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.input.addEventListener('input', () => {
        this.cancel();
        this.close();
        this.timer = setTimeout(() => this.search(), 300);
      }, options);
      this.input.addEventListener('focus', () => {
        if (this.input.value.trim()) this.search();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          this.input.focus();
          this.cancel();
          this.close();
        }
        if (event.key === 'ArrowDown' && !this.panel.hidden) {
          const links = [...this.panel.querySelectorAll('a[href]')];
          const index = links.indexOf(document.activeElement);
          if (links.length) {
            event.preventDefault();
            links[(index + 1) % links.length].focus();
          }
        }
        if (event.key === 'ArrowUp' && !this.panel.hidden) {
          const links = [...this.panel.querySelectorAll('a[href]')];
          const index = links.indexOf(document.activeElement);
          event.preventDefault();
          (links[index - 1] || this.input).focus();
        }
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) { this.cancel(); this.close(); }
      }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.cancel(); this.close(); }
      }, options);
      this.querySelector('form').addEventListener('submit', event => {
        if (!this.input.value.trim()) event.preventDefault();
      }, options);
    }
    cancel() {
      clearTimeout(this.timer);
      this.request?.abort();
    }
    close() {
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }
    async search() {
      const query = this.input.value.trim();
      if (!query) { this.close(); return; }
      this.request?.abort();
      const request = this.request = new AbortController();
      const url = new URL(this.dataset.url, location.origin);
      const fields = ['title', 'product_type', 'vendor', 'variants.sku', 'variants.title'];
      if (this.dataset.tags === 'true') fields.push('tag');
      if (this.dataset.body === 'true') fields.push('body');
      url.search = new URLSearchParams({
        q: query, section_id: 'predictive-search',
        'resources[options][unavailable_products]': this.dataset.unavailable || 'last',
        'resources[options][fields]': fields.join(',')
      });
      const fullSearch = new URL(this.querySelector('form').action);
      fullSearch.search = new URLSearchParams({ q: query, 'options[prefix]': 'last' });
      this.all.href = fullSearch.href;
      this.querySelector('[data-inline-query]').textContent = query;
      this.results.replaceChildren();
      this.status.textContent = 'Searching…';
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      try {
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (request.signal.aborted || this.input.value.trim() !== query) return;
        const markup = doc.querySelector('#shopify-section-predictive-search');
        if (!markup) throw new Error('Missing results');
        this.results.innerHTML = markup.innerHTML;
        this.results.querySelectorAll('a').forEach(link => link.removeAttribute('tabindex'));
        this.status.textContent = this.results.querySelector('a') ? '' : 'No results found.';
      } catch (error) {
        if (error.name !== 'AbortError') this.status.textContent = 'Suggestions unavailable. Press Enter to search.';
      }
    }
    disconnectedCallback() {
      this.cancel();
      this.events?.abort();
      this.events = null;
    }
  });
}
